import type { Company } from "@/apis/gql/types";
import { gql, useQuery } from "@apollo/client";

export const useGetAllCompanies = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const { data, error, loading, refetch } = useQuery<{
    userCompanies: Company[];
  }>(USER_COMPANIES_QUERY, {
    skip: !enabled,
  });

  return { companies: data?.userCompanies ?? [], error, loading, refetch };
};

export const USER_COMPANIES_QUERY = gql`
  query {
    userCompanies {
      companyId
      companyName
      status
      companySlug
      hasCostCenters
      paymentEnabled
      ocrReviewRequired
      diy
      accountingFirmId
      invoiceInboxEnabled
      vorsteuerabzug
      createdAt
      owner {
        userId
        name
        email
      }
      users {
        userId
        name
        email
        systemRole
        companyRole
      }
    }
  }
`;
